import { RbacFeature, RbacFeatureDetails, RbacApiPermission } from '@evidentid/tprm-portal-lib/models/rbac';

type EntityDetailsFeatures = Extract<RbacFeature,
    | RbacFeature.entityDetailsEditProperties
    | RbacFeature.entityDetailsAddRemoveException
    | RbacFeature.entityDetailsForceSubmission
>;

export const ENTITY_DETAILS_FEATURE_PERMISSIONS_MAP: Record<EntityDetailsFeatures, RbacFeatureDetails> = {
    [RbacFeature.entityDetailsEditProperties]: {
        name: RbacFeature.entityDetailsEditProperties,
        label: 'Edit entity properties',
        requiredPermissions: [
            RbacApiPermission.entityPut,
        ],
    },
    [RbacFeature.entityDetailsAddRemoveException]: {
        name: RbacFeature.entityDetailsAddRemoveException,
        label: 'Add or remove an exception',
        requiredPermissions: [
            RbacApiPermission.entityDeleteException,
            RbacApiPermission.entityPostExceptions,
        ],
    },
    [RbacFeature.entityDetailsForceSubmission]: {
        name: RbacFeature.entityDetailsForceSubmission,
        label: 'Force processing',
        requiredPermissions: [
            RbacApiPermission.verificationsPostForceSubmission,
        ],
    },
};
